import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteLocalEstoqueCadastro } from '../service';
import {
  DELETE_LOCAL_ESTOQUE_CADASTRO,
  DELETE_LOCAL_ESTOQUE_CADASTRO_PENDING,
  DELETE_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
  DELETE_LOCAL_ESTOQUE_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteLocalEstoqueCadastro(action) {
  yield put({ type: DELETE_LOCAL_ESTOQUE_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.LOCAL_ESTOQUE_EXCLUIR);

  try {
    const a = yield call(deleteLocalEstoqueCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_LOCAL_ESTOQUE_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_LOCAL_ESTOQUE_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se o local não possuí lançamentos vinculados e tente novamente...');
  }
}

export default function* watchDeleteLocalEstoqueCadastro() {
  yield takeLatest(DELETE_LOCAL_ESTOQUE_CADASTRO, sagaDeleteLocalEstoqueCadastro)
}
